"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Modal = require("@insided/shared/uikit/Modal");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var MarkAsNotSpamModal = function MarkAsNotSpamModal(_ref) {
  var isOpen = _ref.isOpen,
      onMarkAsNotSpam = _ref.onMarkAsNotSpam,
      _onClose = _ref.onClose,
      subTitle = _ref.subTitle;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: isOpen,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Mark as not spam?",
    onClose: function onClose() {
      return _onClose();
    }
  }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("div", {
    className: "mark-as-not-spam-modal"
  }, (0, _preact.h)(_phrase.default, {
    p: subTitle
  }))), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
    title: "Mark as not spam",
    onClick: onMarkAsNotSpam,
    size: "medium",
    variant: "primary",
    "data-qa": "confirm-mark-as-not-spam",
    "data-track-type": "click",
    "data-element-name": "Mark as not spam button"
  }), (0, _preact.h)(_Button.default, {
    title: "Cancel",
    onClick: _onClose,
    size: "medium",
    "data-track-type": "click",
    "data-element-name": "Cancel mark as not spam button"
  })));
};

var _default = MarkAsNotSpamModal;
exports.default = _default;